import { getHostTenantSlug } from './tenantResolver';

const AUTH_LOCAL_KEYS = [
  'token',
  'user',
  'currentOrganization',
  'dev_tenant',
  'refreshToken',
  'collectionsNavState',
] as const;

/**
 * Remove all persisted auth/tenant session data so a new login starts from URL only.
 */
export function clearAuthAndTenantStorage(queryClient?: { clear: () => void }): void {
  for (const key of AUTH_LOCAL_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }

  try {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('tenant_') || key.startsWith('auth_')) {
        localStorage.removeItem(key);
      }
    });
  } catch {
    /* ignore */
  }

  try {
    const sessionKeys: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (
        key &&
        (key.startsWith('tenant_valid_') ||
          key === 'auth_handoff_until' ||
          key.startsWith('collections_'))
      ) {
        sessionKeys.push(key);
      }
    }
    sessionKeys.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    /* ignore */
  }

  try {
    queryClient?.clear();
  } catch {
    /* ignore */
  }

  try {
    void import('../services/functionService').then((m) => m.invalidateCustomFunctionsCache());
  } catch {
    /* ignore */
  }
}

/** True when stored user tenant slug matches the current subdomain (or not on a tenant host). */
export function storedSessionMatchesHost(storedUserJson: string | null): boolean {
  const hostSlug = getHostTenantSlug();
  if (!hostSlug) {
    return true;
  }
  if (!storedUserJson) {
    return false;
  }
  try {
    const user = JSON.parse(storedUserJson) as { organizationSlug?: string };
    const userSlug = String(user?.organizationSlug || '').trim().toLowerCase();
    return userSlug.length > 0 && userSlug === hostSlug.toLowerCase();
  } catch {
    return false;
  }
}
